import { PID_VALUE } from './regexes'

/**
 * Match the last segment: "-L<something><optionally numbers>" at the end
 *
 * Ej: 500977-160-LE25 => LE | 500977-170-L125 => L1 | 500977-172-LQ25 => LQ
 * @param {string} pid - the string of the parameter.
 */
export const getLCode = (pid = '') => {
  const match = pid.match(PID_VALUE)
  if (!match) return null

  const letters = match[1].toUpperCase()
  const numbers = match[2] || ''

  if (letters === 'L' && numbers) {
    return `L${numbers[0]}`
  }

  return letters
}
